import api from 'configs/api';

import { IJustification } from 'interfaces/Justification';
import { IRequestListResponse } from 'interfaces/RequestListResponse';

const endpointUrl = 'justification';

export const getJustificationOptions = async () => {
  const url = `${endpointUrl}`;
  const { data } = await api.get<IRequestListResponse<IJustification>>(url);
  return data;
};
